<n-slide-window *ngIf="pageReady" [visible]="windowVisible" [width]="isSimpleMode ? '6.08rem' : '7rem'" (onHide)="close()">
    <n-header>
        <h1>{{ i18n.title.modifyClient}}</h1>
        <n-help-link key="nfsModifyClient" *ngIf = "!isSimpleMode"></n-help-link>
        <n-help-link key="simplifynfsManage" *ngIf="isSimpleMode"></n-help-link>
        <n-checkbox id="modify-client-nfs-share_advanced" style="margin-left: auto;" [label]="i18n.label.advance"
            [(ngModel)]="advanced"
            *ngIf="!isSimpleMode">
        </n-checkbox>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="isSimpleMode"
            [ngClass]="{ 'form-width-simple': isSimpleMode, 'common-form': !isSimpleMode }">
        <!-- 类型  不允许修改，只展示-->
        <n-form-item [label]="i18n.label.type">
            {{utilService.getLabelFromOptions(str.clientTypeOpts, data._type)}}
        </n-form-item>

        <!-- 前台表格，允许修改 -->
        <ng-container *ngIf="isFrontTable">
            <!-- 主机 -->
            <n-form-item *ngIf="data._type === ClientType.host" [label]="i18n.label.client" required="true">
                <input type="text" id="modify-client-nfs-share_host_name" nInput formControlName="hostName">
            </n-form-item>
            <!-- 网络组 -->
            <n-form-item *ngIf="data._type === ClientType.net" [label]="i18n.label.client" required="true">
                <input type="text" id="modify-client-nfs-share_net_name" nInput formControlName="netName">
            </n-form-item>
        </ng-container>

        <!-- 后台表格，只展示 -->
        <ng-container *ngIf="!isFrontTable">
            <!-- 主机 -->
            <n-form-item *ngIf="data._type === ClientType.host" [label]="i18n.label.client">
                {{data.NAME}}
            </n-form-item>
            <!-- 网络组 网络组有个@符号，展示的时候要干掉 -->
            <n-form-item *ngIf="data._type === ClientType.net" [label]="i18n.label.client">
                {{data.NAME.substr(1)}}
            </n-form-item>
        </ng-container>

        <!-- UNIX权限级别 -->
        <n-form-item [label]="i18n.label.unixPermissionLab" required="true">
            <n-select id="modify-client-nfs-share_permission_dropdown"
                formControlName="unixPermission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- Kerberos5权限级别 -->
        <n-form-item [label]="i18n.label.kerberos5PermissionLab" [required]="true" *ngIf="!isSimpleMode && !ProductConfig.isHideKerberos">
            <n-select id="add-client-nfs-share-kerberos5-permission"
                formControlName="kerberos5Permission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- Kerberos5i权限级别 -->
        <n-form-item [label]="i18n.label.kerberos5iPermissionLab" [required]="true" *ngIf="!isSimpleMode && !ProductConfig.isHideKerberos">
            <n-select id="add-client-nfs-share-kerberos5i-permission"
                formControlName="kerberos5iPermission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- Kerberos5p权限级别 -->
        <n-form-item [label]="i18n.label.kerberos5pPermissionLab" [required]="true" *ngIf="!isSimpleMode && !ProductConfig.isHideKerberos">
            <n-select id="add-client-nfs-share-kerberos5p-permission"
                formControlName="kerberos5pPermission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- root权限限制 -->
        <n-form-item [label]="i18n.label.root_squash"
            [helpContent]="i18n.tip.root_squash"
            [required]="true">
            <n-radio-group id="modify-client-nfs-share_root_squash"
                formControlName="root_squash">
                <n-radio *ngFor="let option of str.root_squashOpts"
                    [id]="'modify-client-nfs-share_root_squash_'+ option.value"
                    [value]="option.value">
                    {{option.label}}
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <n-collapse-list id="simple-advance-setting-collapse"
            [title]="i18n.label.advancedSettingTitle"
            *ngIf="isSimpleMode"
            class="simple-advance-setting-collapse">
            <ng-container [ngTemplateOutlet]="advanceTemplate">
            </ng-container>
        </n-collapse-list>

        <ng-container *ngIf="!isSimpleMode && advanced"
            [ngTemplateOutlet]="advanceTemplate">
        </ng-container>

        <!-- 高级选项 -->
        <ng-template #advanceTemplate>
            <!-- 权限限制 -->
            <n-form-item [label]="i18n.label.all_squash" [helpContent]="i18n.tip.all_squash">
                <n-radio-group id="modify-client-nfs-share_all_squash" formControlName="all_squash">
                    <n-radio *ngFor="let option of str.all_squashOpts"
                        [id]="'modify-client-nfs-share_all_squash_'+ option.value" [value]="option.value">
                        {{option.label}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>
            <!-- 源端口校验限制 -->
            <n-form-item [label]="i18n.label.secure" [helpContent]="i18n.tip.secure">
                <n-radio-group id="modify-client-nfs-share_secure" formControlName="secure">
                    <n-radio *ngFor="let option of str.secureOpts"
                        [id]="'modify-client-nfs-share_secure_'+ option.value" [value]="option.value">
                        {{option.label}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>
            <!-- 匿名用户ID -->
            <n-form-item [label]="i18n.label.anonymousUserId"
                [helpContent]="i18n.tip.anonymousUserId">
                <n-spinner id="add-client-nfs-anonymous-user-id"
                    [style.width]="isSimpleMode ? '' : '1.7rem'"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    [min]="ANONYMOUS_ID_RANGE.MIN"
                    [max]="ANONYMOUS_ID_RANGE.MAX"
                    formControlName="anonymousUserId">
                </n-spinner>
            </n-form-item>
        </ng-template>
    </form>

    <n-footer>
        <button id="modify-client-nfs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="modify-client-nfs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
